<template>
  <div id="app" style="background-color: #f5f4f5;">
    <nav class="navbar navbar-expand-md bg-light navbar-light fixed-top">
      <router-link class="nav-logo" to="/">
        <img :src="imgSrc" alt="" />
      </router-link>
      <span class="navbar-brand">&nbsp;&nbsp;{{_Global.APP_NAME}}</span>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
          </li>
          <!-- <li class="nav-item active">
            <router-link to="/">
              <span class="nav-link">首页</span>
            </router-link>
          </li> -->
          <!-- <li class="nav-item">
            <router-link :to="{name:'SuperSign'}">
              <span class="nav-link">超级签名</span>
            </router-link>
          </li> -->
          <li class="nav-item">
            <router-link :to="{name:'SuperSignApps'}">
              <span class="nav-link">应用管理</span>
            </router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link :to="{name:'Fenfa'}">
              <span class="nav-link">分发管理</span>
            </router-link>
          </li> -->
          <!-- <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">免费企业签名</a>
            <div class="dropdown-menu">
              <router-link :to="{name:'ESign'}">
                <span class="dropdown-item">自助签名</span>
              </router-link>
              <router-link to="/sign/manager">
                <span class="dropdown-item">签名管理</span>
              </router-link>
            </div>
          </li> -->
          <!-- <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">免签封装</a>
            <div class="dropdown-menu">
              <router-link to="/app/mobielconfig/make">
                <span class="dropdown-item">无闪退封装</span>
              </router-link>
              <router-link to="/app/mobielconfig">
                <span class="dropdown-item">封装列表</span>
              </router-link>
            </div>
          </li> -->
          <li v-if="account.inviteCode" class="nav-item">
            <span class="nav-link">我的邀请码（{{account.inviteCode}}）</span>
          </li>
        </ul>
        <form v-if="noLogin" class="my-2 my-lg-0">
          <el-button @click="doLogin" type="primary" round>登录</el-button>
          <!-- <el-button @click="doRegister" type="success" round>注册</el-button> -->
        </form>
        <form v-else class="my-2 my-lg-0">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{account.account}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/appleDeveloperAccount/manager">开发者账号中心</el-dropdown-item>
              <el-dropdown-item v-if="account.caStatus!=2" divided command="/identify">实名认证</el-dropdown-item>
              <el-dropdown-item divided command="/order">我的订单</el-dropdown-item>
              <el-dropdown-item divided command="/update/password">修改密码</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          &nbsp;&nbsp;&nbsp;&nbsp;
        </form>
      </div>
    </nav>
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title">
              <span @click="ranking_top10" style="cursor: pointer;">总排行&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>|&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span @click="ranking_today" style="cursor: pointer;">今日排行</span>
            </p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul v-for="app,index in appList">
              <li style="list-style-type: none;">
                <span style="float: left;">{{index+1}}</span>
                <span>{{app.appName}}({{app.osName}})</span>
                <span style="float: right;margin-right: 3em;">{{app.downNum}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <router-view :key="$route.path + $route.query.flag" v-on:setNoLogin="setNoLogin" v-on:setAccount="setAccount" />

    <!--bar-->
    <!-- <div class="fixed-bar">
      <div class="bar-cell">
        <div class="barlink">
          <span class="wx-icon"></span>
          <p>微信</p>
          <div class="wbox"><img :src="wxSrc" alt="" /></div>
        </div>
        <a target="_blank" :href="_Global.QQ_TUIGUANG" class="barlink">
          <span class="qq-icon"></span>
          <p>QQ</p>
        </a>
        <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=903987432&site=qq&menu=yes" class="barlink">
          <span class="qq-icon"></span>
          <p>QQ</p>
        </a>
        <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=918636986&site=qq&menu=yes" class="barlink">
          <span class="qq-icon"></span>
          <p>QQ</p>
        </a>
      </div>
      <div class="bar-kefu"><a target="_blank" :href="_Global.QQ_TUIGUANG" class="barlink"></a></div>
    </div> -->
  </div>
</template>
<script>
var self;
export default {
  name: "App",
  mounted: function() {
    self = this;
    var token = this.getToken();
    console.log("token ==> " + token);
    if (token != null) {
      this.getAccount(function(account) {
        self.account = account;
        self.noLogin = false;
      });
    }
  },
  data() {
    return {
      noLogin: true,
      account: {},
      appList: [],
      imgSrc: require("assets/images/logo.png"),
      wxSrc: require("assets/images/wx.jpg")
    };
  },
  methods: {
    setPhone: function(phone) {
      this.phone = phone;
    },
    logout: function() {
      this.removeToken();
      this.noLogin = true;
      this.$router.push("/login");
    },
    setNoLogin: function(noLogin) {
      this.noLogin = noLogin;
    },
    setAccount: function(account) {
      this.account = account;
    },
    show_ranking: function() {
      this.ranking_top10();
      $("#myModal").modal("show");
    },
    ranking_top10: function() {
      this.$http
        .get(this._Global.HTTP_SERVER + "/app/ranking/top10")
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            self.appList = data;
          });
        });
    },
    ranking_today: function() {
      this.$http
        .get(this._Global.HTTP_SERVER + "/app/today/ranking/top10")
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            self.appList = data;
          });
        });
    },
    doLogin: function() {
      this.$router.push("/login");
    },
    doRegister: function() {
      this.$router.push("/register");
    },
    handleCommand: function(command) {
      if (command == "logout") {
        this.logout();
      } else {
        this.$router.push(command);
      }
    },
    wait: function() {
      this.$alert(
        "因苹果官方接口调整，暂时停止全自动超级签业务，开放时间敬请期待！",
        "友情提示",
        {
          showClose: false,
          callback: action => {
            this.$router.push({name:"SignOnline"})
          }
        }
      );
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.text-overflow {
  display: block;
  /*内联对象需加*/
  /* width: 31em; */
  word-break: keep-all;
  /* 不换行 */
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis;
  /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
}
</style>
<style scoped>
.navbar {
  background-color: white !important;
}

@media only screen and (min-width: 2000px) {
  .collapse {
    margin-left: 200px !important;
  }
  .nav-item {
    margin-left: 50px !important;
    margin-right: 50px !important;
    cursor: pointer;
  }
  .nav-logo {
    margin-left: 100px !important;
  }
}

@media (max-width: 768px) {
  .banner-img {
    margin-top: 2em;
    height: 16em;
  }
}

@media only screen and (min-width: 1200px) {
  .banner-img {
    margin-top: 6em;
    height: 25em;
    width: 35em;
  }

  .collapse {
    margin-left: 80px;
  }
  .nav-item {
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }
  .nav-logo {
    margin-left: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue